export const handleUppercaseChange = (
    e,
    handleChange
) => {
    e.target.value = e.target.value.toUpperCase();
    handleChange(e);
};